/**vue instance */
import Vue from "vue/dist/vue"

/**  send ajax request */
import Axios from "axios"

/** vee validate */
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate"
import { required } from "vee-validate/dist/rules"
import fa from "vee-validate/dist/locale/fa"
extend("required", required)
/** vee validate */

/**custom national code rule */
extend("nationalcode", {
  validate: (value) => {
    if (!/^\d{10}$/.test(value)) return false

    if (/^(\d)\1+$/.test(value)) return false

    var check = +value[9]
    var sum =
      Array(9)
        .fill()
        .map((_, i) => +value[i] * (10 - i))
        .reduce((x, y) => x + y) % 11
    return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11)
  },
  message: "قالب کد ملی وارد شده صحیح نیست",
})
localize("fa", fa)

/**don't show the production tip in logs */
Vue.config.productionTip = false

/** ngProgress for ajax calls */
import NProgress from "vue-nprogress"
Vue.use(NProgress)
const nprogress = new NProgress()
import MyNProgress from './components/NProgress'
Vue.component('my-nprogress', MyNProgress)
/** ngProgress for ajax calls */

// ***__Notifications__ (StarT)***
import Notifications from "vue-notification"
Vue.use(Notifications)
// ***__Notifications__ (EnD)***

/**sweet alert */
import Swal from 'sweetalert2/src/sweetalert2.js'

/**make devtools off in production */
if (process.env.MIX_APP_ENV == 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

new Vue({
  nprogress,
  el: "#register",
  data() {
    return {
      nationalcode: null,
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    // only can write a number
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    /**check sejam registeration */
    async submit() {
      
      /**check validation */
      let res = await this.$refs.nationalCodeRef.validate()
      if (!res.valid) {
        /**validation failed */
        this.$notify({
          text: "لطفا ورودی ها را چک نمایید!",
          type: "error",
          title: "اخطار!",
        })
        return
      }

      /**check user signed up before or not */
      try {
        let data = {
          nationalcode: this.nationalcode,
        }
        /**reset ngprogress */
        this.$nprogress.done()
        this.$nprogress.start()
        await Axios.post("/get-investor", data)
        /**investor exists! signup abort! */
        this.$nprogress.done()
        
        await Swal.fire({
          title: '',
          html: 'شما قبلا در صندوق ثبت نام کرده اید! <br> لطفا از فرم ورود وارد سایت شوید!',
          icon: 'info',
          confirmButtonText: 'بسیارخب',
          showClass: {
            popup: 'animated fadeIn'
          },
          hideClass: {
            popup: 'animated fadeOut'
          },
          allowOutsideClick : false ,
          allowEscapeKey : false , 
          allowEnterKey : false 
        })
        
        /**go login form */
        location.href = '/login'
        return
      } catch (error) {
        /** do nothing user not found in FUND let signup began! */
      }


      /**send login request */
      try {
        let data = {
          nationalcode: this.nationalcode,
        }
        /**reset ngprogress */
        this.$nprogress.inc(0.4)
        await Axios.post("send-sejam-verify", data)
        location.href = "/register-verify";
      } catch (error) {
        console.error(error)
        this.$nprogress.done()
        this.$notify({
          text: "کد ملی مورد نظر در سجام ثبت نشده است." + "\n" + "لطفا ثبت نام را از طریق پر کردن فرم ادمه دهید",
          type: "warn",
          title: "هشدار!",
          ignoreDuplicates: true,
        })
      }
    },

    /**go to signup form without sejam */
    signupWithSignupForm() {
      this.$nprogress.start()
      location.href = '/register-personal-info';
      this.$nprogress.done()
    },
  },
})
